import glancer from './assets/glancer.jpg';
import animex from './assets/animex.jpg';
import cosmos from './assets/cosmos.jpg';
import watchFlix from './assets/watchflix.jpg';
import reddit from './assets/reddit.jpg';
import ecommerce from './assets/ecommerce.jpg';

const projectsList = [
  {
    name: 'GLancer',
    image: glancer,
    description: 'a platform that combines clients with freelancers that offers various tools and services that make it easier for freelancers to find work and find the talent needed to manage projects for clients.',
    demo: 'https://g-lancer.onrender.com/',
    code: 'https://github.com/CA-G12/g-lancer',
  },
  {
    name: 'Cosmos',
    image: cosmos,
    description: "Cosmos is a website where you can see other people's thoughts about cosmos, also you can publish your own Posts built with email-password authentication.",
    demo: 'https://cosmos-g12.herokuapp.com/',
    code: 'https://github.com/CA-G12/cosmos',
  },
  {
    name: 'OREBI',
    image: ecommerce,
    description: 'E-commerce website that sells clothes, shoes & jewelry online and allows you to search, buy, sign up and sign in to be able to add to the cart.',
    demo: 'https://store-6rd4.onrender.com/',
    code: 'https://github.com/CA-G12/E-Commerce-Team3',
  },
  {
    name: 'Reddit Clone',
    image: reddit,
    description: 'This is a clone of the Reddit app which is a network of communities where people can dive into their interests, hobbies and passions. ',
    demo: 'https://shatha-reddit.herokuapp.com/',
    code: 'https://github.com/CA-G12/Shatha-Reddit',
  },
  {
    name: 'Watchflix',
    image: watchFlix,
    description: 'is an application specially built for the user to find their favourite movies and music. This application will be like a movie keeper where the user is able to find and download the movies.',
    demo: 'https://ca-g12.github.io/API-shatha-nader-abdallah/',
    code: 'https://github.com/CA-G12/Watchflix',
  },
  {
    name: 'AnimeX',
    image: animex,
    description: 'This is an anime website that features animes based on your search. Also, it provides you with GIFs that are related to the anime you like.',
    demo: 'https://animex-gsg.herokuapp.com/',
    code: 'https://github.com/CA-G12/AnimeX',
  },

];

export default projectsList;
